var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav"},[_c('div',{staticClass:"nav-tabs"},_vm._l((_vm.tabList),function(tab){return _c('div',{key:tab.index,class:tab.index === _vm.selectTabIndex ? 'tab-items selected' : 'tab-items',on:{"click":function($event){return _vm.changeRouter(tab)}}},[_vm._v(_vm._s(tab.name))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }